import { createSlice } from '@reduxjs/toolkit';
import { fetchDailyTotalsSummaryReportThunk, fetchPermittedLocationsThunk } from './thunks';
import { fetchDailyTotalsReportReducers, fetchPermittedLocationsReducers } from './reducers';
import { IDailyTotalsSummaryReportState } from './types';

const initialState: IDailyTotalsSummaryReportState = {
  items: [],
  permittedLocations: {
    totalCount: 0,
    results: [],
  },
  pagination: {
    start: 0,
    length: 0,
    limit: 0,
    total: 0,
  },
  loading: {},
  errors: {},
};

const dailyTotalsReportSlice = createSlice({
  name: 'dailyTotalsSummaryReport',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDailyTotalsSummaryReportThunk.pending, fetchDailyTotalsReportReducers.pending);
    builder.addCase(fetchDailyTotalsSummaryReportThunk.fulfilled, fetchDailyTotalsReportReducers.fulfilled);
    builder.addCase(fetchDailyTotalsSummaryReportThunk.rejected, fetchDailyTotalsReportReducers.rejected);

    builder.addCase(fetchPermittedLocationsThunk.pending, fetchPermittedLocationsReducers.pending);
    builder.addCase(fetchPermittedLocationsThunk.fulfilled, fetchPermittedLocationsReducers.fulfilled);
    builder.addCase(fetchPermittedLocationsThunk.rejected, fetchPermittedLocationsReducers.rejected);
  },
});

export const { actions, reducer } = dailyTotalsReportSlice;
